var AdaptiveImage = require("../../../node_modules/react-native-web-image-loader/lib/modules/adaptiveImage.js").default;

module.exports = new AdaptiveImage({
    uri: __webpack_public_path__ + "static/media/cross.904bba47.png","uri@2x": __webpack_public_path__ + "static/media/cross.ebb46aff.png","uri@3x": __webpack_public_path__ + "static/media/cross.c6c862ba.png",
    width: 14,
    height: 12
});